import axios from 'axios';

const get = () => axios.get(process.env.REACT_APP_HOLIDAYS_API_URL).then(res => res.data);

export default { get };
